// extracted by mini-css-extract-plugin
module.exports =  {"page":"yV_SyU5tUU75zSicGtUM","chip":"_TST0VXFRwJFBwYXcfKU","logo":"Yr9FQZkBavaOUV71ziPQ","footer":"Gct3lYZXim8OUOm0hrWy"};